import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/loadsmart-ui'

import { screen } from 'legacy/styles/screen'

import { type Carrier } from '../domain/Carrier'

const StyledLayoutStack = styled(Layout.Stack)`
  align-items: flex-start;
  padding-top: 24px;

  ${screen.lg} {
    align-items: flex-end;
  }
`

const StyledText = styled(Text)`
  :after {
    content: ' • ';
  }

  :last-child:after {
    content: none;
  }
`

export type CarrierInformationProps = {
  carrier: Carrier
}

export function CarrierInformation({ carrier }: CarrierInformationProps) {
  return (
    <StyledLayoutStack space="xs">
      {carrier.name && <Text variant="body-bold">{carrier.name}</Text>}
      <Layout.Group space="xs">
        {carrier.mc && <StyledText>{`MC ${carrier.mc}`}</StyledText>}
        {carrier.dot && <StyledText>{`DOT ${carrier.dot}`}</StyledText>}
        {carrier.scac && <StyledText>{`SCAC ${carrier.scac}`}</StyledText>}
        {carrier.email && <StyledText>{carrier.email}</StyledText>}
      </Layout.Group>
    </StyledLayoutStack>
  )
}
